export class ErrorUtils {
    /**
     * Extrai uma mensagem de erro de forma segura e genérica
     * @param {any} error - erro capturado (AxiosError, Error, etc)
     * @returns {string} mensagem de erro amigável
     */
    static getErrorMessage(error) {
      if (!error) return "Erro desconhecido.";

      // Axios error
      if (this.isAxiosError(error)) {
        const data = error.response?.data;

        if (typeof data === "string") return data;

        if (typeof data === "object" && data !== null) {
          if (data.message && typeof data.message === "string") {
            return data.message;
          }

          if (
            data.notification &&
            typeof data.notification === "object" &&
            data.notification.messageReturn
          ) {
            return data.notification.messageReturn;
          }
        }

        return error.message || "Erro de comunicação com o servidor.";
      }

      // Erro genérico (ex: throw new Error)
      if (error instanceof Error) {
        return error.message || "Erro desconhecido.";
      }

      return "Erro inesperado.";
    }

    static isAxiosError(error) {
      return !!error.isAxiosError;
    }
  }